import Vue from 'vue'
import {dd,store,app} from 'systems/imports'

import BaseProcessor from 'processor/BaseProcessor'
import API from 'api/Cart'

/**
 * 運営サイト情報
 */
class Cart extends BaseProcessor{
  static getClassName(){ return 'Event' }

  /**
   */
  static cartPreparation(input){
    return new Promise(function(resolve, reject) {
      API.cartPreparation(input)
        .then((res)=>{
          return resolve({status:"ok",data:{cart:res.cart} })
        }).catch((e)=>{
        switch(e.name){
        }
      })
    });
  }

  static getCartPhotos(input){
    return new Promise(function(resolve, reject) {
      API.getCartPhotos(input)
        .then((res)=>{
          return resolve({status:"ok",data:{cart_photos:res.cart_photos} })
        }).catch((e)=>{
        switch(e.name){
        }
      })
    });
  }

  static addCartPhoto(input){
    return new Promise(function(resolve, reject) {
      API.addCartPhoto(input)
        .then((res)=>{
          return resolve({status:"ok",data:{cart_photo:res.cart_photo} })
        }).catch((e)=>{
        switch(e.name){
        }
      })
    });
  }

  static removeCartPhoto(input){
    return new Promise(function(resolve, reject) {
      API.removeCartPhoto(input)
        .then((res)=>{
          return resolve({status:"ok",data:{} })
        }).catch((e)=>{
        switch(e.name){
        }
      })
    });
  }

  static updateCartPhotoSize(input){
    return new Promise(function(resolve, reject) {
      API.updateCartPhotoSize(input)
        .then((res)=>{
          return resolve({status:"ok",data:{photo_size:res.photo_size} })
        }).catch((e)=>{
        switch(e.name){
        }
      })
    });
  }

  static addCartPhotoPurchaseTarget(input){
    return new Promise(function(resolve, reject) {
      API.addCartPhotoPurchaseTarget(input)
        .then((res)=>{
          return resolve({status:"ok",data:{} })
        }).catch((e)=>{
        switch(e.name){
        }
      })
    });
  }

  static removeCartPhotoPurchaseTarget(input){
    return new Promise(function(resolve, reject) {
      API.removeCartPhotoPurchaseTarget(input)
        .then((res)=>{
          return resolve({status:"ok",data:{} })
        }).catch((e)=>{
        switch(e.name){
        }
      })
    });
  }

  static getPurchaseTargetCartPhotos(input){
    return new Promise(function(resolve, reject) {
      API.getPurchaseTargetCartPhotos(input)
        .then((res)=>{
          return resolve({status:"ok",data:{cart_photos:res.cart_photos} })
        }).catch((e)=>{
        switch(e.name){
        }
      })
    });
  }

  static commitOrder(input){
    return new Promise(function(resolve, reject) {
      API.commitOrder(input)
        .then((res)=>{
          return resolve({status:"ok",data:{order:res.order} })
        }).catch((e)=>{
        switch(e.name){
        }
      })
    });
  }




}

export default Cart



// WEBPACK FOOTER //
// ./src/processor/Cart.js